@if (open && job) {
  <div class="fixed inset-0 z-[10040] bg-black/75 backdrop-blur-sm" aria-hidden="true"></div>

  <section
    class="fixed inset-0 z-[10041] flex items-center justify-center p-4"
    role="dialog"
    aria-modal="true"
  >
    <div class="w-full max-w-md rounded-xl border border-[#32455d] bg-[#111821] shadow-2xl">
      <div class="p-6">
        <h3 class="m-0 text-2xl font-bold text-[#f6faff]">{{ title() }}</h3>
        <p class="mt-3 text-sm leading-6 text-[#9eb0c9]">{{ job.stage }}</p>

        <div class="mt-5">
          <div class="mb-2 flex items-center justify-between text-sm">
            <span class="text-[#d7e4f6]">Progress</span>
            <span class="font-bold text-[#2d9dff]">{{ job.progress }}%</span>
          </div>
          <div class="h-3 overflow-hidden rounded-full bg-[#2a3a4f]">
            <div
              class="h-full bg-[#2d9dff] transition-all duration-500"
              [style.width]="progressWidth()"
            ></div>
          </div>
        </div>

        @if (job.status === 'success' && job.fileName) {
          <div
            class="mt-5 rounded-lg border border-[#33475f] bg-[#182534] p-3 text-xs text-[#a8bbd2]"
          >
            <p class="m-0">
              File: <span class="font-semibold text-[#f0f6ff]">{{ job.fileName }}</span>
            </p>
            <p class="m-0 mt-1">Target: {{ job.target }}</p>
          </div>
        }

        @if (job.status === 'failed' && job.errorMessage) {
          <div
            class="mt-5 rounded-lg border border-[#60384a] bg-[#2a1b24] p-3 text-xs text-[#ffb2c8]"
          >
            <p class="m-0">{{ job.errorMessage }}</p>
            @if (job.errorCode) {
              <p class="m-0 mt-1 font-mono">{{ job.errorCode }}</p>
            }
          </div>
        }
      </div>

      <div class="flex gap-3 border-t border-[#2b3b4f] bg-[#16202d] px-6 py-4">
        @if (job.status === 'running') {
          <button
            type="button"
            (click)="emitCancelBackup()"
            [disabled]="cancelLoading"
            class="h-10 flex-1 rounded-lg border border-[#3f5068] bg-[#223248] text-sm font-bold text-[#dce9f9] transition hover:bg-[#2b4260] disabled:cursor-not-allowed disabled:opacity-60"
          >
            {{ cancelLoading ? 'Canceling...' : 'Cancel Backup' }}
          </button>
        } @else {
          <button
            type="button"
            (click)="emitClose()"
            class="h-10 flex-1 rounded-lg bg-[#2d9dff] text-sm font-bold text-white transition hover:bg-[#2288e4]"
          >
            Close
          </button>
          @if (job.status === 'success') {
            <button
              type="button"
              (click)="emitDownloadBackup()"
              [disabled]="!downloadAvailable"
              class="h-10 flex-1 rounded-lg border border-[#4b607b] bg-[#2b3d54] text-sm font-bold text-[#e9f2ff] transition hover:bg-[#365070] disabled:cursor-not-allowed disabled:opacity-60"
            >
              Download Backup
            </button>
          }
        }
      </div>
    </div>
  </section>
}
